import { render, staticRenderFns } from "./suggestParticipates.vue?vue&type=template&id=97bb14fe&scoped=true&"
import script from "./suggestParticipates.vue?vue&type=script&lang=ts&"
export * from "./suggestParticipates.vue?vue&type=script&lang=ts&"
import style0 from "./suggestParticipates.vue?vue&type=style&index=0&id=97bb14fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bb14fe",
  null
  
)

export default component.exports